import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { siteData } from '../mockData';
import { ArrowRight } from 'lucide-react';

const ContactCTASection = () => {
  return (
    <section className="relative py-28 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${siteData.images.consultationPhoto})`
        }}
      >
        <div className="absolute inset-0 bg-black/65"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-xs tracking-[0.3em] text-gray-400 uppercase mb-4">Ready to Start?</p>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-light text-white leading-tight mb-6">
          Get in touch
        </h2>
        <div className="w-16 h-[1px] bg-white/30 mx-auto mb-6"></div>
        <p className="text-lg text-gray-300 mb-10 max-w-xl mx-auto">
          Make your next move with Mazen today.
        </p>
        <Link to="/contact">
          <Button 
            size="lg"
            className="bg-white text-black hover:bg-gray-100 transition-all duration-500 rounded-full px-10 text-sm font-semibold tracking-wide group"
          >
            CONTACT MAZEN
            <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-300" size={16} />
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default ContactCTASection;
